/* Demo stub — brak połączenia z API */
import { mockPassTransactions } from "../demo/mockPassTransactions";
import {
  getMockAvailablePlayersApiResponse,
  getMockFolderDetailApiResponse,
  getMockFolderDetailResponse,
  getMockOwnFoldersApiResponse,
  getMockRootFoldersApiResponse,
  getMockStructureSearchResponse,
  grantMockFolderToTrainer,
  revokeMockFolderToTrainer,
} from "../demo/mockStructure";
import { createNamedStub } from "../demo/stubHelpers";

export const getRootFolder = async (academyId?: string) =>
  getMockRootFoldersApiResponse(academyId);

export const getAvailablePlayerFolders = async (academyId?: string) =>
  getMockAvailablePlayersApiResponse(academyId);

export const getFolderDetail = async (academyId?: string, folderId?: string) =>
  getMockFolderDetailApiResponse(academyId, folderId);

export const getPlayerPasses = async (_academyId?: string, folderId?: string) => {
  const folder = getMockFolderDetailResponse(folderId);
  const playerIds = new Set(
    (folder?.Items ?? []).map((item: { PlayerId: string }) => item.PlayerId)
  );

  const playerPasses = mockPassTransactions.filter(
    (transaction) =>
      playerIds.has(transaction.Player.PlayerId) ||
      transaction.Groups?.some((group) => group.GroupId === folderId)
  );

  return { Data: { PlayerPasses: playerPasses } };
};

export const getFolderItemsByFolderId = async (
  _academyId?: string,
  folderId?: string
) => {
  const items = getMockFolderDetailResponse(folderId)?.Items ?? [];
  return {
    Data: items.map((item: any) => ({
      ...item,
      FolderId: folderId,
    })),
  };
};

export const GetOwnFolders = async (academyId?: string) =>
  getMockOwnFoldersApiResponse(academyId);

export const getSearchFolders = async (
  searchQuery?: string,
  academyId?: string
) => getMockStructureSearchResponse(searchQuery, academyId);

export const getSearchFolderPath = createNamedStub({ Data: { Path: [] } });
export const createFolder = createNamedStub({ Success: true });
export const createSubFolder = createNamedStub({ Success: true });
export const addItemToFolder = createNamedStub({ Success: true });
export const updateFolderName = createNamedStub({ Success: true });
export const grantFolderToTrainer = grantMockFolderToTrainer;
export const revokeFolderToTrainer = revokeMockFolderToTrainer;
export const copyItemToFolder = createNamedStub({ Success: true });
export const transferItemToFolder = createNamedStub({ Success: true });
export const replaceItem = createNamedStub({ Success: true });
export const deleteFolderItem = createNamedStub({ Success: true });
export const deleteFolder = createNamedStub({ Success: true });
